module.exports = __webpack_public_path__ + "static/media/wit_logo.16ebb73c.svg";